import { render, staticRenderFns } from "./ServicosUnidade.vue?vue&type=template&id=cf4292d6&scoped=true"
import script from "./ServicosUnidade.vue?vue&type=script&lang=js"
export * from "./ServicosUnidade.vue?vue&type=script&lang=js"
import style0 from "./ServicosUnidade.vue?vue&type=style&index=0&id=cf4292d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4292d6",
  null
  
)

export default component.exports